/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcknowledgeProjectFreelancerItemRequest
 */
export interface AcknowledgeProjectFreelancerItemRequest {
    /**
     * 
     * @type {string}
     * @memberof AcknowledgeProjectFreelancerItemRequest
     */
    type: AcknowledgeProjectFreelancerItemRequestTypeEnum;
    /**
     * Optional lot id for per-lot acknowledgment (time & materials). Null for project-level.
     * @type {string}
     * @memberof AcknowledgeProjectFreelancerItemRequest
     */
    lotId?: string;
}


/**
 * @export
 */
export const AcknowledgeProjectFreelancerItemRequestTypeEnum = {
    ProjectRenewalDismissed: 'PROJECT_RENEWAL_DISMISSED',
    PaymentStatusViewed: 'PAYMENT_STATUS_VIEWED'
} as const;
export type AcknowledgeProjectFreelancerItemRequestTypeEnum = typeof AcknowledgeProjectFreelancerItemRequestTypeEnum[keyof typeof AcknowledgeProjectFreelancerItemRequestTypeEnum];


/**
 * Check if a given object implements the AcknowledgeProjectFreelancerItemRequest interface.
 */
export function instanceOfAcknowledgeProjectFreelancerItemRequest(value: object): value is AcknowledgeProjectFreelancerItemRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function AcknowledgeProjectFreelancerItemRequestFromJSON(json: any): AcknowledgeProjectFreelancerItemRequest {
    return AcknowledgeProjectFreelancerItemRequestFromJSONTyped(json, false);
}

export function AcknowledgeProjectFreelancerItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcknowledgeProjectFreelancerItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'lotId': json['lotId'] == null ? undefined : json['lotId'],
    };
}

export function AcknowledgeProjectFreelancerItemRequestToJSON(value?: AcknowledgeProjectFreelancerItemRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'lotId': value['lotId'],
    };
}

